import * as tslib_1 from "tslib";
import Vue from 'vue';
import Router from 'vue-router';
import VueHtmlToPaper from 'vue-html-to-paper';
import App from './App.vue';
import store from './store';
import i18n from './config/i18n';
import axios from 'axios';
// // 引入自定义指令
// import directives from './directives';
import env from '@/config/env';
import routes from './routes';
import * as platform from '@cloudpivot/platform';
import './config/api';
import './config/antd';
import './styles/index.less';
import { utils } from '@cloudpivot/common';
let importReportService = false;
const whiteRouteNames = ['login', 'oauth', 'appointmentVisitor', 'authenticationRedirect'];
/**
 * 页面禁用拖拽上传时 浏览器默认打开图片
 */
document.addEventListener('drop', function (e) {
    e.preventDefault();
}, false);
document.addEventListener('dragover', function (e) {
    e.preventDefault();
}, false);
const jsonToStr = (data) => {
    const d = Object.assign({}, data);
    delete d.empNo;
    delete d.corpId;
    return Object.entries(d).map(([key, val]) => [key, val].join('=')).join('&');
};
export function getFeishuLoginParams(data, configAppId) {
    return {
        code: data.code,
        corpId: platform.getFeishuCorpId(data) || data.state,
        appId: platform.getFeishuAppId(data, configAppId)
    };
}
export function startup(environment) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        // 地址参数上携带access_token的，将token存在localstorage并清理地址上的参数
        if (environment && environment.access_token) {
            // 通过token获取refresh_token，实现token续期
            yield axios.post(`${env.apiHost}/login/Authentication/get_refresh_token`, { access_token: environment.access_token }).then((res) => {
                if (res.errcode === 0 && res.data) {
                    const refresh_tokens = res.data.refresh_token;
                    let expireTime = res.data.expiration;
                    // 时间戳如果为13位则单位是ms,把单位转为s
                    if (expireTime.toString().length === 13) {
                        expireTime = expireTime.toString().slice(0, -3);
                    }
                    localStorage.setItem('refresh_token', refresh_tokens);
                    localStorage.setItem('expireTime', expireTime);
                }
            });
            //打开表单详情时不清理access_token, 原因为 解决钉钉打开流程表单点击同意后不关闭页面问题
            if (!window.location.href.includes('/form/detail?')) {
                const url = decodeURIComponent(window.location.href).replace('&access_token', 'access_token');
                window.location.href = url.replace(`access_token=${environment.access_token}`, '');
            }
        }
        window.Environment = environment;
        window.Environment.isIe = /Trident/.test(navigator.userAgent);
        Vue.config.productionTip = false;
        Vue.use(Router);
        Vue.use(VueHtmlToPaper);
        // 单应用路由
        if (window.Environment.appCode) {
            (routes[0]).redirect = '/app-home';
        }
        else if (window.Environment.messageId) {
            // 消息路由
        }
        const router = new Router({
            mode: 'history',
            base: process.env.BASE_URL,
            routes
        });
        Vue.prototype.router = router;
        router.beforeEach((to, from, next) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let title = '夕尔控股';
            if (to.meta && to.meta.title) {
                title = to.meta.title;
            }
            platform.service.setTitle(title);
            if (to.name === 'appReport' && !importReportService) {
                importReportService = true;
                import('@/views/applications/report-service');
            }
            if (to.name === 'applicationReport' && !importReportService) {
                importReportService = true;
                import('@/views/applications/report-service');
            }
            if (to.name === 'applicationReport' && !importReportService) {
                importReportService = true;
                import('@/views/applications/report-service');
            }
            const token = localStorage.getItem('token');
            if (Vue.prototype.$httpRequestList.length > 0) { //强行中断时才向下执行
                Vue.prototype.$httpRequestList.forEach((item) => {
                    item('interrupt'); //给个标志，中断请求
                });
            }
            if (env.enableProxy) {
                next();
            }
            else {
                const data = utils.parseQuery();
                const { code, state } = data;
                if (code && state) {
                    const params = getFeishuLoginParams(data, window.config.appId);
                    const res = yield axios.get('/login/feishu', { params });
                    if (res.errcode === 0) {
                        localStorage.setItem('refresh_token', res.refresh_token);
                        localStorage.setItem('expireTime', res.expiration);
                        localStorage.setItem('token', res.access_token);
                        const copyUrl = localStorage.getItem('copy_link_url_path');
                        if (copyUrl) {
                            localStorage.removeItem('copy_link_url_path');
                            window.open(copyUrl, "_self");
                        }
                        else {
                            location.href = location.origin;
                        }
                        return;
                    }
                }
                if (!token && !whiteRouteNames.includes(to.name)) {
                    next({ name: 'login' });
                }
                else {
                    next();
                }
            }
        }));
        // 全局注册自定义指令
        // Object.entries(directives).forEach((directive: any) => {
        //     const directiveName = directive[0];
        //     const directiveFunc = directive[1];
        //     Vue.directive(directiveName, directiveFunc);
        // });
        new Vue({
            router,
            i18n,
            store,
            render: (h) => h(App),
        }).$mount('#app');
    });
}
